Object.defineProperty(exports,"__esModule",{value:true});exports.VISIBLE_ITEMS=void 0;var VISIBLE_ITEMS=6;exports.VISIBLE_ITEMS=VISIBLE_ITEMS;
//# sourceMappingURL=InputDropdown.definition.js.map